<template>
  <VoteBase>
    <template v-slot:voteMain>
      <voteItemForm :func="funcType" :isUpdate="isUpdate" :defaultLimitConfig="defaultLimitConfig" @submitData="submitData($event)" />
    </template>
  </VoteBase>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'
import voteItemForm from '@/components/Vote/VoteItemForm'
import VoteBase from './Base'

export default {
  name: 'item-update',
  components: {voteItemForm, VoteBase},
  mixins: [Error],
  data () {
    return {
      funcType: '修改',
      isUpdate: true,
      data: null,
      defaultLimitConfig: {}
    }
  },
  methods: {
    submitData (data) {
      api.updateVoteData(this, api.getVoteItemUpdate(), 'POST', data, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.backToList)
    },
    backToList () {
      this.$router.push({name: 'vote-item', params: {appId: this.$route.params.appId}, query: {oversea: JSON.parse(this.$route.query.oversea)}})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ItemUpdate.vue?66e991c7